// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgf_a bhl_vt bhl_ea bhl_a","MenuItem__Btn":"bgf_b bhl_z","MenuItem__subtitle":"bgf_c"};